export const parseFileName = (nameWithExtension) => {
  let nameWithoutExt = null;
  let ext = null;

  if (nameWithExtension) {
    const index = nameWithExtension.lastIndexOf('.');
    if (index > 0) {
      nameWithoutExt = nameWithExtension.slice(0, index);
      ext = nameWithExtension.slice(index);
    } else {
      nameWithoutExt = nameWithExtension;
      ext = '';
    }
  }

  return {
    nameWithoutExt,
    ext,
  };
};
